import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7375e7e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slideshow-container" }
const _hoisted_2 = { class: "numbertext" }
const _hoisted_3 = ["src", "onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { style: {"text-align":"center"} }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "popover-content" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "mySlides fade",
          style: _normalizeStyle({ display: _ctx.current === i ? 'block' : 'none' })
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(i + 1) + " / " + _toDisplayString(_ctx.images.length), 1),
          _createElementVNode("img", {
            src: img,
            style: {"width":"100%"},
            onClick: ($event: any) => (_ctx.selectedImage = img)
          }, null, 8, _hoisted_3)
        ], 4))
      }), 128)),
      _createElementVNode("a", {
        class: "prev",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
      }, "❮"),
      _createElementVNode("a", {
        class: "next",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
      }, "❯")
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, i) => {
        return (_openBlock(), _createElementBlock("span", {
          class: _normalizeClass(["dot", { active: _ctx.current === i }]),
          key: i,
          onClick: ($event: any) => (_ctx.goTo(i))
        }, null, 10, _hoisted_6))
      }), 128))
    ]),
    (_ctx.selectedImage)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", {
            class: "image-popover",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedImage = null))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: _ctx.selectedImage,
                alt: ""
              }, null, 8, _hoisted_8)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}